/**
 * @copyright Microsoft Corporation. All rights reserved.
 *
 * @file Analytics Activity component
 */

import * as React from 'react';
import { ActivityItem } from 'office-ui-fabric-react/lib/components/ActivityItem/index';
import { IActivity } from '../../../models/ItemAnalytics';
import * as StringHelper from '@ms/utilities-strings/lib/index';
import strings from '../FileHoverCard.resx';
import { isCurrentLoginUser } from '../UserNameHelper';
import * as AnalyticsActivityStyle from './AnalyticsActivity.scss';

export interface IAnalyticsActivityProps {
  activity: IActivity;
  loginUserEmail?: string;
  userEmail?: string;
}

export interface IAnalyticsActivityStrings {
  accessActivity: string;
  modifiedActivity: string;
  loginUserYou?: string;
  activityTemplate?: string;
}

export const AnalyticsActivity: React.StatelessComponent<IAnalyticsActivityProps> = (props: IAnalyticsActivityProps) => {
  const { activity, loginUserEmail, userEmail } = props;

  let activityActionString = '';
  if (activity.activityType === 'Access') {
    activityActionString = strings.accessActivity;
  } else if (activity.activityType === 'Modified') {
    activityActionString = strings.modifiedActivity;
  }
  const user = activity && activity.actor && activity.actor.user;
  const userName = isCurrentLoginUser(user && user.email, loginUserEmail, userEmail) ?
    strings.you : activity.actor.user.displayName;

  const userNameJsx = (
    <div className={ `${AnalyticsActivityStyle.msAnalyticsActivityUserName}` }>
      { userName }
    </div>
  );

  const userActionString = (
    <div className={ `${AnalyticsActivityStyle.msAnalyticsActivityUserAction}` }>
      { activityActionString }
    </div>
  );

  // Insert JSX into string.
  const userAction = StringHelper.formatToArray(strings.activityTemplate, userNameJsx, userActionString);

  return (
    <ActivityItem
      activityPersonas={ [{ imageUrl: activity.actor.user.image, imageAlt: activity.actor.user.displayName }] }
      activityDescription={
        <div className={ `${AnalyticsActivityStyle.msAnalyticsActivity}` }>
          { userAction }
        </div>
      }
      timeStamp={ activity.activityDateTime }
    />
  );
};